import React from 'react'
import ResetPassword from '../components/auth/js/ResetPassword'
const ResetPage = () => {
  return (
    <ResetPassword/>
  )
}

export default ResetPage